import { IGlobalStore } from 'src/types/store'
import {
  TStateCommunications,
  createStateSagaCommunications,
} from 'src/helpers/redux'
import { Actions, actions } from './actions'
import * as settingsServiceTypes from 'src/services/storage/settings/types'

export interface IValidationError {
  identifier: string
  message: string
}

export interface IStateData {
  settings: settingsServiceTypes.IGetSettingsData
}

export interface IState {
  data: IStateData
  communication: TStateCommunications<Actions>
}

export const getInitialData = (): IStateData => {
  return {
    settings: {
      subdomain: '',
      timeZone: '',
      mailAutoCreationEnabled: false,
      communicationMessageAutoCreationEnabled: false,
      communicationCallAutoCreationEnabled: false,
      createdAt: '',
      updatedAt: '',
      mailFieldScheme: undefined,
      mailFirstNameFieldScheme: undefined,
      mailLastNameFieldScheme: undefined,
      communicationFieldScheme: undefined,
    },
  }
}

export const initialState = {
  data: getInitialData(),
  communication: createStateSagaCommunications(actions),
}

export type TGlobalStateWithService = IGlobalStore & {
  [key: string]: IState
}
